import { createComponent } from '@carvana/merch-components';

export const Content = createComponent('div', {
  className:
    'm-xl flex flex-col gap-16 rounded-[6px] border border-grey-2 p-xl m:mx-auto m:max-w-[425px]'
});
